module.exports = __webpack_public_path__ + "media/images/front/treatment_support/menu_on-3631f93dd2180db59a735026c465a492.svg";